import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ImageDetail from "@/pages/ImageDetail";
import About from "@/pages/About";
import Header from "@/components/Header";

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/image/:id" element={<ImageDetail />} />
          <Route path="/about" element={<About />} />
        </Routes>
        <Toaster
          position="bottom-right"
          toastOptions={{
            classNames: {
              toast:
                "rounded-none border-2 border-black bg-white text-black font-mono",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
